<h2 mat-dialog-title>{{'USER.FILTER_USER.FILTER_DATE_ACCESSED' | translate}}</h2>
<mat-dialog-content>
    <section>
        <mat-radio-group color="primary" class="w-full">
            <mat-radio-button *ngFor="let opt of optionFilter;" (change)="onChangeOptionFilter(opt.id) "
                [value]="opt.id" [checked]="opt.id === selectedFilter">
                <span>{{opt.text| translate}}</span>
            </mat-radio-button>
        </mat-radio-group>
        <div *ngIf="!filter.isOptionFilterPeriod">
            <mat-form-field color="primary" class="w-full">
                <mat-label>{{'USER.FILTER_USER.SPECIFIC_DATE' | translate}}</mat-label>
                <input matInput [matDatepicker]="picker6" (click)='picker6.open()' [(ngModel)]="filter.specificDate" />
                <mat-datepicker-toggle matSuffix [for]="picker6">
                    <mat-icon matDatepickerToggleIcon class="material-icons-outlined">
                        calendar_today
                    </mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker6></mat-datepicker>
            </mat-form-field>
        </div>
        <div *ngIf="filter.isOptionFilterPeriod">
            <mat-form-field color="primary" class="w-full">
                <mat-label>{{'COMMON.DATE_FROM_TO' | translate}}</mat-label>
                <mat-date-range-input [rangePicker]="picker" (click)="picker.open()">
                    <input matStartDate placeholder="Start date" readonly [(ngModel)]="filter.fromDate" />
                    <input matEndDate placeholder="End date" readonly [(ngModel)]="filter.toDate" />
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker">
                    <mat-icon matDatepickerToggleIcon class="material-icons-outlined">
                        calendar_today
                    </mat-icon>
                </mat-datepicker-toggle>
                <mat-date-range-picker panelClass="qms-date" #picker></mat-date-range-picker>
            </mat-form-field>
        </div>
    </section>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-stroked-button color="primary" (click)="closeFilter(false)">{{'COMMON.CANCEL' | translate}}</button>
    <button mat-flat-button color="primary" (click)="saveFilter()">{{'COMMON.SAVE' | translate}}</button>
</mat-dialog-actions>